import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect, useContext } from 'react';
import EditTable from './EditTable';
import { UserContext } from '../userContext';
import { phoneTypeList } from '../formatFactoryTool';
var columns = [{
  id: 'name',
  accessor: function accessor(i) {
    return i.customName || i.phoneType && i.phoneType.label;
  }
}, {
  id: 'countryCode',
  Cell: function Cell(_ref) {
    var i = _ref.original;
    return "".concat(i.countryCode && i.countryCode.Code && "+".concat(i.countryCode.Code), "\n        ").concat(i.number, "\n         ").concat(i.extension ? "Ext.".concat(i.extension) : '');
  }
}];

var Phone = function Phone(_ref2) {
  var prefix = _ref2.prefix,
      countryCodeList = _ref2.countryCodeList,
      isCountryCodeLoading = _ref2.isCountryCodeLoading,
      trans = _ref2.trans;
  var defaultFormItemList = [{
    visible: true,
    required: true,
    item: {
      type: 'select',
      name: 'phoneType',
      label: trans('SFxUserPreferencesPhoneEmailLabel'),
      relatedName: 'customName',
      renderOption: function renderOption(i) {
        return {
          label: trans(i.name) || i.label,
          value: i.value
        };
      },
      options: phoneTypeList
    }
  }, {
    visible: false,
    required: true,
    item: {
      type: 'text',
      name: 'customName',
      label: trans('SFxUserPreferencesPhoneCustomNameLabel'),
      maxLength: 50
    }
  }, {
    visible: false,
    required: true,
    item: {
      type: 'select',
      name: 'countryCode',
      label: trans('SFxUserPreferencesPhoneCountryCodeLabel'),
      showFlag: true,
      options: countryCodeList,
      isLoading: isCountryCodeLoading,
      renderOption: function renderOption(i) {
        return {
          label: "(+".concat(i.Code, ") ").concat(i.Name, " "),
          value: i.GeonameId
        };
      }
    }
  }, {
    visible: false,
    required: true,
    item: {
      type: 'phoneNum',
      name: 'number',
      label: trans('SFxUserPreferencesPhoneNumberLabel'),
      maxLength: 50
    }
  }, {
    visible: false,
    required: false,
    item: {
      type: 'add',
      name: 'addButton',
      label: trans('SFxUserPreferencesPhoneAddExtText')
    }
  }, {
    visible: false,
    required: false,
    item: {
      type: 'text',
      name: 'extension',
      label: trans('SFxUserPreferencesPhoneExtension'),
      maxLength: 50
    }
  }];

  var _useState = useState(defaultFormItemList),
      _useState2 = _slicedToArray(_useState, 2),
      formItemList = _useState2[0],
      setFormItemList = _useState2[1];

  var _useContext = useContext(UserContext),
      userData = _useContext.userData,
      updateUserData = _useContext.updateUserData;

  var _userData$profile$use = userData.profile.userPhones,
      userPhones = _userData$profile$use === void 0 ? [] : _userData$profile$use;

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      tableData = _useState4[0],
      setTableData = _useState4[1];

  useEffect(function () {
    if (userPhones.length) {
      var tableDataAction = userPhones.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          canDel: !i.main,
          canEdit: true
        });
      });
      setTableData(tableDataAction);
    }
  }, [userPhones]);

  var updateTableData = function updateTableData(userPhones) {
    setTableData(userPhones);

    var profile = _objectSpread(_objectSpread({}, userData.profile), {}, {
      userPhones: userPhones
    });

    updateUserData(_objectSpread(_objectSpread({}, userData), {}, {
      profile: profile
    }));
  };

  var updateFormItemList = function updateFormItemList(currentObject) {
    var _currentObject$phoneT = currentObject.phoneType,
        phoneType = _currentObject$phoneT === void 0 ? {
      value: ''
    } : _currentObject$phoneT,
        addButton = currentObject.addButton;
    var newFormItemList = [].concat(defaultFormItemList);

    if (phoneType.value) {
      newFormItemList = [].concat(defaultFormItemList).map(function (i) {
        if (phoneType.value === 'custom') {
          return _objectSpread(_objectSpread({}, i), {}, {
            visible: i.item.name !== 'extension'
          });
        } else {
          return _objectSpread(_objectSpread({}, i), {}, {
            visible: !(i.item.name === 'extension' || i.item.name === 'customName')
          });
        }
      });
      setFormItemList(newFormItemList);
    }

    if (addButton === 'add') {
      newFormItemList = _toConsumableArray(newFormItemList).filter(function (i) {
        return i.item.name !== 'addButton';
      }).map(function (i) {
        return i.item.name === 'extension' ? _objectSpread(_objectSpread({}, i), {}, {
          visible: true
        }) : i;
      });
      setFormItemList(newFormItemList);
    }

    if (!phoneType.value) {
      setFormItemList(defaultFormItemList);
    }
  };

  return /*#__PURE__*/React.createElement(EditTable, {
    prefix: prefix,
    addButtonText: trans('SFxUserPreferencesAddPhoneNumberText'),
    containerId: "phoneTab",
    tableData: tableData,
    columns: columns,
    formItemList: formItemList,
    updateTableData: updateTableData,
    updateFormItemList: updateFormItemList,
    trans: trans
  });
};

export default Phone;